import { useRef } from "react";

export const SignaturePad = ({ onChange, dataTestId, clearTestId = "signature-clear", height = 160, className = "" }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);

  const point = (e) => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    return [(e.clientX - r.left) * (c.width / r.width), (e.clientY - r.top) * (c.height / r.height)];
  };
  const down = (e) => {
    e.preventDefault();
    drawing.current = true;
    last.current = point(e);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    const p = point(e);
    ctx.strokeStyle = "#0f172a";
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(last.current[0], last.current[1]);
    ctx.lineTo(p[0], p[1]);
    ctx.stroke();
    last.current = p;
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    onChange("");
  };

  return (
    <div>
      <canvas
        ref={ref}
        width={560}
        height={height}
        data-testid={dataTestId}
        onPointerDown={down}
        onPointerMove={move}
        onPointerUp={up}
        onPointerLeave={up}
        className={`w-full touch-none rounded-xl border border-slate-300 bg-white ${className}`}
        style={{ height }}
      />
      <button
        type="button"
        data-testid={clearTestId}
        onClick={clear}
        className="mt-2 text-[11px] font-bold uppercase tracking-widest text-slate-500 transition-colors hover:text-slate-900"
      >
        Clear signature
      </button>
    </div>
  );
};
